export default __webpack_public_path__ + "static/1920X938_SLIDER_NIE_KUPUJ_ADOPTUJ-4f13ed077b7f722a22c11e31d3ff7f25.jpg";